<template>
    <v-flex fill-height>
        <sidemainmenu></sidemainmenu>
        <br />
        <v-progress-linear slot="extension" :indeterminate="true"  v-if="loading" class="ma-0"></v-progress-linear>
        <v-alert :value="alertsuccess" color="success" icon="new_releases">
                {{ alertsmessage }}
        </v-alert>
        <v-layout wrap justify-space-between>
            <v-card  class="mx-auto" min-width="100%">
            <v-card-title>
                <v-layout wrap justify-space-between>
                    <v-flex xs12 md2>
                        <v-menu v-model="dtSfromdate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="dtsfrdate" label="From Date" prepend-icon="event" readonly
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dtsfrdate" @input="dtSfromdate = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 md2>
                        <v-menu v-model="dtStodate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="dtstdate" label="To Date" prepend-icon="event" readonly
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dtstdate" @input="dtStodate = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 class="py-2">
                        <v-btn color="info" v-on:click="getData()">
                            <span>Search</span>
                            <v-icon>search</v-icon>
                        </v-btn>
                        <v-btn color="success" v-on:click="seen = !seen">
                            <span>Add New / List</span>
                            <v-icon>add</v-icon>
                        </v-btn>
                        <v-btn color="error" v-on:click="clearData()">
                            <span>Clear</span>
                            <v-icon>loop</v-icon>
                        </v-btn>
                      </v-flex>
                    <v-flex xs12 md2>
                        <h3 class="py-4">SEAL BREAKING</h3>
                    </v-flex>
                </v-layout>
            </v-card-title>
            <v-card-text>
                <v-card v-if="seen">
                    <v-card-title>
                        <export-excel
                            title = "VCFS Seal Breaking"
                            :data   = "sealbreaking_details">
                            <v-btn color="cyan">
                            <v-icon color="white">file_copy</v-icon>
                        </v-btn>
                        </export-excel>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="sealbreaking_details" :search="search" class="elevation-1" :rows-per-page-items="[15, 10, 30, 40]">
                        <template v-slot:items="props">
                            <td>{{ props.index + 1 }}</td>
                            <td class="text-xs-right">{{ props.item.cont_no }}</td>
                            <td class="text-xs-right">{{ props.item.sizetype }}</td>
                            <td class="text-xs-right">{{ props.item.sb_date }}</td>
                            <td class="text-xs-right">{{ props.item.delivery_mode }}</td>
                            <td class="text-xs-right">{{ props.item.customer }}</td>
                            <td class="text-xs-right">{{ props.item.importer }}</td>
                            <td class="text-xs-right">{{ props.item.be_no }}</td>
                            <td class="text-xs-right">{{ props.item.be_date }}</td>
                            <td class="text-xs-right">{{ props.item.igm_no }}</td>
                            <td class="text-xs-right">{{ props.item.igm_date }}</td>
                            <td class="text-xs-right">{{ props.item.bl_no }}</td>
                            <td class="text-xs-right">{{ props.item.bl_date }}</td>
                            <td class="text-xs-right">{{ props.item.cont_ref_no }}</td>
                            <td class="text-xs-right">{{ props.item.Cargo_ass_amount }}</td>
                            <td class="text-xs-right">{{ props.item.duty_amount }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card  v-else>
                    <v-form v-model="valid" ref="form">
                    <v-card-text class="mx-auto">
                        <v-container grid-list-xl>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md3>
                                </v-flex>
                                <v-flex xs12 md2>
                                    <v-text-field v-model="txtSigm_no" label="Search By IGM" autofocus required ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md2>
                                    <v-btn  color="info" v-on:click="getSIGMDetails()">Search<v-icon right dark>search</v-icon></v-btn>
                                </v-flex>
                                <v-flex xs12 md2>
                                    <v-select @change="onChange()" v-model="cbobl_no" :items="igm_list" item-value="id" label="Select BL" item-text="text"  :rules="[(v) => !!v || 'BL is required']"></v-select>
                                </v-flex>
                                <v-flex xs12 md3>
                                </v-flex>
                            </v-layout>
                            <v-card justify-center>
                                <v-card-text primary-title v-for="(bl, index) in bl_list" v-bind:key="index">
                                    <v-layout>
                                        <v-flex xs12 md2>
                                            <v-text-field :value=" bl.cont_no" label="Container No." readonly></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md2>
                                            <v-text-field :value=" bl.size_type" label="Size Type" readonly></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md2>
                                            <v-text-field :value=" bl.line" label="Line" readonly></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md2>
                                            <v-checkbox v-model="bl.is_seal_breaked" label="Select Seal Break" required></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>

                            <v-card justify-center>
                            <v-card-text primary-title>
                                <v-layout>
                                    <v-flex xs12 md2>
                                        <v-select v-model="cbodelivery_mode" :items="delivery_mode" item-value="id" item-text="text"  :rules="[(v) => !!v || 'Delivery Mode is required']"  label="Select Delivery Mode"></v-select>
                                    </v-flex>
                                    <v-flex xs12 md2>
                                        <v-select v-model="cbocustomer" :items="customer_list" item-value="id" item-text="text"  :rules="[(v) => !!v || 'CHA is required']"  label="Select CHA"></v-select>
                                    </v-flex>
                                    <v-flex xs12 md2>
                                        <v-text-field v-model="txtImporter" label="Importer Name"   :rules="[(v) => !!v || 'Importer Name is required']" ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md2>
                                        <v-text-field v-model="txtbentry" label="Bill of Entry"   :rules="[(v) => !!v || 'Bill of Entry is required']" ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md2>
                                        <v-menu v-model="dpbentry" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="dtbentry" label="BE Date" prepend-icon="event" readonly
                                            v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="dtbentry" @input="dpbentry = false"  :rules="[(v) => !!v || 'BE Date is required']"></v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                            <v-card-text class="mx-auto">
                                <v-container grid-list-xl>
                                    <v-layout wrap justify-space-between>
                                        <v-flex xs12 md3>
                                            <v-text-field v-model="txttot_ass_value" label="Total Ass. Value" :rules="[(v) => !!v || 'Total Ass. Value is required']"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field v-model="txtdutyamount" label="Duty Amount"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-btn color="success" v-bind:disabled="btnDisable" v-on:click="submitData()">Save</v-btn>
                                            <v-btn color="error" v-on:click="clearData()">Clear</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                        </v-container>
                    </v-card-text>
                </v-form>
                </v-card>
            </v-card-text>
            </v-card>
        </v-layout>
    <br />
    <bottomfootermenus></bottomfootermenus>
    </v-flex>
</template>


<script>
import sidemainmenu from '@/components/header.vue';
import bottomfootermenus from '@/components/footer.vue';
import axios from 'axios';
    const toLower = text => {
            return text.toString().toLowerCase()
        }

        const searchByName = (items, term) => {
            if (term) {
              return items.filter(item => toLower(item.name).includes(toLower(term)))
            }

            return items
        }
  export default {
    name: 'sealbreakings',
    data() {
        return {
            error: false,
            valid: false,
            alerterror: false,
            alertsuccess: false,
            alertsmessage: null,
            errors: null,
            seen: true,
            search: null,
            igm_list: [],
            sealbreaking_details: [],
            gatein_details: [],
            bl_list: [],
            vessel_list: [],
            dtsfrdate: null,
            dtstdate: null,
            dtSfromdate: false,
            dtStodate: false,
            activeVal: "Open",
            btnDisable: false,
            loading: false,
            txtSigm_no: null,
            txtigmno: null,
            cbobl_no: null,
            cbodelivery_mode: null,
            cbocustomer: null,
            txtImporter: null,
            txtbentry: null,
            txttot_ass_value: null,
            txtdutyamount: null,
            dtbentry: new Date().toISOString().substr(0, 10),
            dpbentry: false,
            crossDomain : true,
            xhrFields: {
                withCredentials: true
            },
            search: '',
            headers: [
              { text: 'S.No', align: 'left', value: 'index' },
              { text: 'Container No', align: 'right', value: 'cont_no' },
              { text: 'Size Type', align: 'right', value: 'sizetype' },
              { text: 'SB Date', align: 'right', value: 'sb_date' },
              { text: 'Delivery Type', align: 'right', value: 'delivery_mode' },
              { text: 'Customer', align: 'right', value: 'customer' },
              { text: 'Importer', align: 'right', value: 'importer' },
              { text: 'BE No', align: 'right', value: 'be_no' },
              { text: 'BE Date', align: 'right', value: 'be_date' },
              { text: 'IGM', align: 'right', value: 'igm_no' },
              { text: 'IGM Date', align: 'right', value: 'igm_date' },
              { text: 'BL', align: 'right', value: 'bl_no' },
              { text: 'BL Date', align: 'right', value: 'bl_date' },
              { text: 'Total Ass Value', align: 'right', value: 'Cargo_ass_amount' },
              { text: 'Duty Amount', align: 'right', value: 'duty_amount' },
              { text: 'Work Order', align: 'right', value: 'cont_ref_no' }
            ],
            delivery_mode: [
                {
                  text: 'FCL',
                  id: 1
                },
                {
                  text: 'De-Stuff',
                  id: 2
                },
                {
                  text: 'LCL',
                  id: 3
                }
            ]
        }
    },
    mounted:function(){
        this.getData(),
        this.getCustomer()
    },
    components: {
        sidemainmenu,
        bottomfootermenus,
    },
    methods: {
        getData: function () {
            this.loading = true;
            if(this.dtsfrdate !== null && this.dtstdate !== null) {
                this.API_URL = this.$hostname + "/seal_breakings?from_date=" + this.dtsfrdate + "&to_date=" + this.dtstdate
            } else {
                this.API_URL = this.$hostname + "/seal_breakings?limit=15"
            }
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.loading = false;
                this.sealbreaking_details = response.data;
            }, (error) => {
                this.loading = false;
                this.errors = error.response.data.result;
                alert(this.errors);
            })
        },
        searchOnTable () {
            this.state = searchByName(this.state, this.search)
        },
        getSIGMDetails: function () {
            if (this.txtSigm_no === null) {
                alert("Please Enter IGM Number");
            } else {
                this.API_URL = this.$hostname + "/search_bls?igm_no=" + this.txtSigm_no
                this.loading = true;
            }
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.igm_list = response.data;
                this.loading = false;
            }, (error) => {
                this.errors = error.response.data.error;
                this.loading = false;
                alert("IGM Not Found, Please Check");

            })
        },
        onChange() {
            this.loading = true;
            if (this.cbobl_no === null) {
                alert("Select BL Details");
            } else {
                this.API_URL = this.$hostname + "/search_sb_containers/" + this.cbobl_no
            }
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.bl_list = response.data.result;
                this.loading = false;
            }, (error) => {
                this.errors = error.response.data.error;
                this.loading = false;
                this.alerterror = true;
                window.location.reload();

            })
        },
        getCustomer: function () {
            this.API_URL = this.$hostname + "/combos/customer"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.customer_list = response.data;
            }, (error) => {
                this.errors = error.response.data.error;
                this.alerterror = true;
            })
        },
        submitData: function() {
            if(!this.$refs.form.validate()) {
                return false
            }
            this.btnDisable = true;
            this.loading = true;
            const sealbreaking_data = {
                'delivery_mode': this.cbodelivery_mode,
                'customer': this.cbocustomer,
                'importer': this.txtImporter,
                'be_no': this.txtbentry,
                'be_date': this.dtbentry,
                'tot_ass_value': this.txttot_ass_value,
                'duty_amount': this.txtdutyamount,
                'created_by': localStorage.username
            }
            const data = {'crossDomain': true,
                          'cont_data': this.bl_list,
                          'sb_data': sealbreaking_data
                        }
            axios.post(this.$hostname + '/seal_breakings', data,
                       { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
                 .then(response => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.alertsuccess = true;
                    this.alertsmessage = response.data.message;
                    alert(this.alertsmessage);
                    window.location.reload();
                 }, (error) => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.errors = error.response.data.error;
                    alert(this.errors);
                    window.location.reload();
                })
        },
        clearData: function() {
            this.dtsfrdate = null;
            this.dtstdate = null;
            this.dtSfromdate = false;
            this.dtStodate = false;
            this.txtigmno = null;
            this.dtSfromdate = null;
            this.dtStodate = null;
            this.dt_portout = null;
            this.dt_cfsin = null;
            this.txtSigm_no = null;
            this.txtsealno = null;
            this.txtsblno = null;
            this.txtsline = null;
            this.txtssizetype = null;
            this.txtscargo = null;
            this.txttruckno = null;
            this.txttransortname = null;
            this.txteirno = null;
            this.txttot_ass_value = null;
            this.txtdutyamount = null;
        }
    }
  }
</script>

<style lang="stylus" scoped>
      .v-progress-circular
        margin: 1rem
    .loading-overlay
        z-index: 10
        top: 0
        left: 0
        right: 0
        position: absolute
        width: 100%
        height: 100%
        background: rgba(255, 255, 255, 0.9)
        display: flex
        align-items: center
        justify-content: center
</style>
